import { useState } from "react";
import { Link } from "react-router-dom";

export default function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [linkReset, setLinkReset] = useState("");

  async function solicitarReset(e) {
    e.preventDefault();
    setErro("");
    setMensagem("");
    setLinkReset("");

    if (!email) {
      setErro("Informe seu e-mail.");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch("https://app.nvplaydigital.com/esqueci-senha", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Erro ao solicitar recuperação de senha.");
      }

      setMensagem(
        data.message ||
          "Se esse e-mail estiver cadastrado, enviaremos as instruções de recuperação."
      );

      // Temporário para fase beta/dev.
      // Quando o envio por e-mail estiver configurado, o backend pode parar de retornar esse link.
      if (data.linkReset) {
        setLinkReset(data.linkReset);
      }
    } catch (err) {
      setErro(err.message || "Erro ao conectar com servidor.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.glow1}></div>
      <div style={styles.glow2}></div>

      <div style={styles.card}>
        <div style={styles.logoArea}>
          <div style={styles.logo}>NV</div>
          <h1 style={styles.title}>Recuperar senha</h1>
          <p style={styles.subtitle}>
            Informe seu e-mail para gerar um link seguro de redefinição.
          </p>
        </div>

        {erro && <div style={styles.errorBox}>{erro}</div>}
        {mensagem && <div style={styles.successBox}>{mensagem}</div>}

        <form onSubmit={solicitarReset} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>E-mail</label>
            <input
              style={styles.input}
              type="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Gerando link..." : "Enviar instruções"}
          </button>
        </form>

        {linkReset && (
          <div style={styles.betaBox}>
            <p style={styles.betaTitle}>Link gerado para teste beta:</p>
            <a href={linkReset} style={styles.betaLink}>
              Abrir link para redefinir senha
            </a>
          </div>
        )}

        <div style={styles.footer}>
          <Link to="/login" style={styles.link}>
            Voltar para o login
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(135deg, #020617 0%, #0f172a 50%, #111827 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    position: "relative",
    overflow: "hidden",
    fontFamily: "Inter, Arial, sans-serif",
  },
  glow1: {
    position: "absolute",
    width: 300,
    height: 300,
    background: "#2563eb",
    borderRadius: "50%",
    filter: "blur(120px)",
    opacity: 0.25,
    top: -80,
    left: -80,
  },
  glow2: {
    position: "absolute",
    width: 300,
    height: 300,
    background: "#0ea5e9",
    borderRadius: "50%",
    filter: "blur(120px)",
    opacity: 0.2,
    bottom: -80,
    right: -80,
  },
  card: {
    width: "100%",
    maxWidth: 430,
    background: "rgba(15,23,42,0.92)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 28,
    padding: 32,
    backdropFilter: "blur(20px)",
    boxShadow: "0 25px 60px rgba(0,0,0,0.45)",
    position: "relative",
    zIndex: 2,
  },
  logoArea: {
    textAlign: "center",
    marginBottom: 28,
  },
  logo: {
    width: 76,
    height: 76,
    borderRadius: 24,
    background: "linear-gradient(135deg,#2563eb,#0ea5e9)",
    margin: "0 auto 18px auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: 27,
    fontWeight: "bold",
    boxShadow: "0 15px 40px rgba(37,99,235,0.4)",
  },
  title: {
    color: "#fff",
    margin: 0,
    fontSize: 28,
    fontWeight: 800,
  },
  subtitle: {
    color: "#94a3b8",
    marginTop: 10,
    fontSize: 14,
    lineHeight: 1.5,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  label: {
    color: "#cbd5e1",
    fontSize: 14,
    fontWeight: 600,
  },
  input: {
    height: 54,
    borderRadius: 16,
    border: "1px solid rgba(255,255,255,0.08)",
    background: "#1e293b",
    padding: "0 18px",
    color: "#fff",
    fontSize: 15,
    outline: "none",
  },
  button: {
    marginTop: 6,
    height: 56,
    borderRadius: 18,
    border: "none",
    background: "linear-gradient(135deg,#2563eb,#0284c7)",
    color: "#fff",
    fontSize: 16,
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: "0 15px 35px rgba(37,99,235,0.35)",
  },
  errorBox: {
    background: "rgba(220,38,38,0.16)",
    border: "1px solid rgba(248,113,113,0.3)",
    color: "#fecaca",
    padding: 12,
    borderRadius: 14,
    marginBottom: 16,
    fontSize: 14,
  },
  successBox: {
    background: "rgba(22,163,74,0.16)",
    border: "1px solid rgba(74,222,128,0.3)",
    color: "#bbf7d0",
    padding: 12,
    borderRadius: 14,
    marginBottom: 16,
    fontSize: 14,
  },
  betaBox: {
    marginTop: 18,
    padding: 14,
    borderRadius: 16,
    background: "rgba(2,132,199,0.14)",
    border: "1px solid rgba(56,189,248,0.25)",
  },
  betaTitle: {
    color: "#cbd5e1",
    margin: "0 0 8px",
    fontSize: 13,
  },
  betaLink: {
    color: "#38bdf8",
    fontWeight: 800,
    textDecoration: "none",
    fontSize: 14,
  },
  footer: {
    marginTop: 24,
    textAlign: "center",
  },
  link: {
    color: "#38bdf8",
    textDecoration: "none",
    fontWeight: 700,
    fontSize: 14,
  },
};
